import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent {
  constructor(private router: Router) {}

  jobSearch(): void {
    this.router.navigate(['/apps/job/search']);
  }
}
